const r = ":host{display:inline-flex;align-items:center;justify-content:center;vertical-align:middle;overflow:hidden;user-select:none;border-radius:var(--sl-radius-full);background-color:hsl(var(--sl-hsl-muted));color:hsl(var(--sl-hsl-muted-foreground));font-family:var(--sl-font-family-base);font-weight:var(--sl-font-weight-medium);position:relative}:host([size='sm']){width:2rem;height:2rem;font-size:var(--sl-font-size-xs)}:host([size='md']),:host(:not([size])){width:2.5rem;height:2.5rem;font-size:var(--sl-font-size-sm)}:host([size='lg']){width:3rem;height:3rem;font-size:var(--sl-font-size-base)}:host([size='xl']){width:4rem;height:4rem;font-size:var(--sl-font-size-lg)}";
class a extends HTMLElement {
  static get observedAttributes() {
    return ["size"];
  }
  constructor() {
    super(), this._shadow = this.attachShadow({ mode: "open" }), this._render();
  }
  attributeChangedCallback(e, t, s) {
    t !== s && this._render();
  }
  get size() {
    return this.getAttribute("size") || "md";
  }
  set size(e) {
    this.setAttribute("size", e);
  }
  _render() {
    this._shadow.innerHTML = `
      <style>${r}</style>
      <slot></slot>
    `;
  }
}
typeof customElements < "u" && !customElements.get("sl-avatar") && customElements.define("sl-avatar", a);
const n = ":host{display:block;position:absolute;inset:0;width:100%;height:100%}:host(.sl-avatar-image--error){display:none}.sl-avatar-img{width:100%;height:100%;object-fit:cover;border-radius:inherit}";
class o extends HTMLElement {
  static get observedAttributes() {
    return ["src", "alt"];
  }
  constructor() {
    super(), this._shadow = this.attachShadow({ mode: "open" }), this._handleErrorBound = this._handleError.bind(this), this._handleLoadBound = this._handleLoad.bind(this), this._render();
  }
  connectedCallback() {
    this._addImgListeners();
  }
  disconnectedCallback() {
    this._removeImgListeners();
  }
  attributeChangedCallback(e, t, s) {
    t !== s && (this._render(), this.isConnected && this._addImgListeners());
  }
  get src() {
    return this.getAttribute("src") || "";
  }
  set src(e) {
    this.setAttribute("src", e);
  }
  get alt() {
    return this.getAttribute("alt") || "";
  }
  set alt(e) {
    this.setAttribute("alt", e);
  }
  _handleError() {
    this.classList.add("sl-avatar-image--error"), this.dispatchEvent(
      new CustomEvent("error", {
        bubbles: !0,
        composed: !0
      })
    );
  }
  _handleLoad() {
    this.classList.remove("sl-avatar-image--error"), this.dispatchEvent(
      new CustomEvent("load", {
        bubbles: !0,
        composed: !0
      })
    );
  }
  _render() {
    this._shadow.innerHTML = `
      <style>${n}</style>
      <img
        class="sl-avatar-img"
        src="${this.src}"
        alt="${this.alt}"
        loading="lazy"
      />
    `;
  }
  _addImgListeners() {
    const e = this._shadow.querySelector("img");
    e && (e.addEventListener("error", this._handleErrorBound), e.addEventListener("load", this._handleLoadBound));
  }
  _removeImgListeners() {
    const e = this._shadow.querySelector("img");
    e && (e.removeEventListener("error", this._handleErrorBound), e.removeEventListener("load", this._handleLoadBound));
  }
}
typeof customElements < "u" && !customElements.get("sl-avatar-image") && customElements.define("sl-avatar-image", o);
const l = ":host{display:flex;width:100%;height:100%;align-items:center;justify-content:center;border-radius:inherit;background-color:inherit;color:inherit;font-size:inherit;font-weight:inherit}";
class d extends HTMLElement {
  constructor() {
    super(), this._shadow = this.attachShadow({ mode: "open" }), this._render();
  }
  _render() {
    this._shadow.innerHTML = `
      <style>${l}</style>
      <slot></slot>
    `;
  }
}
typeof customElements < "u" && !customElements.get("sl-avatar-fallback") && customElements.define("sl-avatar-fallback", d);
export {
  a as SlAvatarElement,
  d as SlAvatarFallbackElement,
  o as SlAvatarImageElement
};
//# sourceMappingURL=sl-avatar.js.map
